import React from "react";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import { colors } from "../../utils/styles";

const isDevelopment = process.env.NODE_ENV === "development";

export default function FormNavButtons({
  step,
  onPrevious,
  onNext,
  onSubmit,
  onPreviewPdf,
  submitting,
  submitted
}) {
  const isLastStep = step >= 3;

  return (
    <Stack
      direction={{ xs: "column-reverse", sm: "row" }}
      justifyContent="space-between"
      spacing={1.5}
      sx={{
        marginTop: "36px",
        paddingTop: "24px",
        borderTop: `1px solid ${colors.borderLight}`
      }}
    >
      <Button
        onClick={onPrevious}
        disabled={step === 0}
        variant="outlined"
        sx={{ borderColor: colors.border, "&:hover": { borderColor: colors.navy } }}
      >
        ← Previous
      </Button>
      {!isLastStep ? (
        <Button onClick={onNext} variant="contained">
          Continue →
        </Button>
      ) : isDevelopment ? (
        <Stack direction={{ xs: "column-reverse", sm: "row" }} spacing={1.5}>
          <Button onClick={onPreviewPdf} variant="outlined" color="secondary">
            Preview PDF (dev)
          </Button>
          <Button onClick={onSubmit} disabled={submitting || submitted} variant="contained" color="success">
            {submitted ? "Submitted ✓" : "Confirm & Submit"}
          </Button>
        </Stack>
      ) : (
        <Button onClick={onSubmit} disabled={submitting || submitted} variant="contained" color="success">
          {submitted ? "Submitted ✓" : "Confirm & Submit"}
        </Button>
      )}
    </Stack>
  );
}
